import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PaginatedList } from '@services/core-services/models/paginated-list';
import { Query } from '@services/core-services/models';
import { CustomerId } from '@services/customer-services/models/customer-id';
import { LoyaltyPointActivityListResponse } from './models/loyaltiy-activity.response';
import { LoyaltyPrograms } from './models/loyaltiy-programs';
import { LoyaltyProgramListResponse } from './models/loyaltiy-program.response';
import { AddLoyaltyPointActivity } from './models/add-loyalty-request';
import { LoyaltyId } from './models/loyalty-id';
import { LoyaltyProgramDetailResponse } from './models/loyaltiy-program-detail.response';
import { CachingApiService } from '@services/core-services/api-cache.service';
import { LoyaltyMember } from './models/loyalty-members';
import { LoyaltyMembersListResponse } from './models/loyalty-members.response';
import { LoyaltyPointActivity } from './models/loyaltiy-activity';
import { ChangeTierManually } from './models/change-tier';

@Injectable({
  providedIn: 'root',
})
export class LoyaltyService {
  loyaltyUrl = 'customers/loyalty-members';
  customerUrl = 'customers';

  constructor(private readonly cacheApi: CachingApiService) {}

  getLoyaltyMembers(query?: Query): Observable<PaginatedList<LoyaltyMember[]>> {
    return this.cacheApi.getWithCache<LoyaltyMembersListResponse>(this.loyaltyUrl, query).pipe(
      map(({ content }: LoyaltyMembersListResponse) => ({
        list: content.loyalty_members,
        pagination: content.pagination,
      }))
    );
  }

  changeTierManually(payload: ChangeTierManually[]): Observable<ChangeTierManually[]> {
    const url = `${this.customerUrl}/loyalty-members/change-tier`;
    return this.cacheApi.post(url, payload);
  }

  getLoyaltyPointActivity(
    customerId: CustomerId,
    query?: Query
  ): Observable<PaginatedList<LoyaltyPointActivity[]>> {
    query = query || {};
    query.limit = query.limit || 10;
    const urlId = `${this.customerUrl}/${customerId}/loyalty-point-activities`;
    return this.cacheApi.getWithCache<LoyaltyPointActivityListResponse>(urlId, query).pipe(
      map(({ content }: LoyaltyPointActivityListResponse) => ({
        list: content.activities,
        pagination: content.pagination,
      }))
    );
  }

  addLoyaltyPoints(
    customerId: CustomerId,
    activity: AddLoyaltyPointActivity
  ): Observable<LoyaltyPointActivityListResponse> {
    const url = `${this.customerUrl}/${customerId}/loyalty-point-activities`;
    const payload = activity;

    return this.cacheApi.post<any, LoyaltyPointActivityListResponse>(url, payload).pipe(
      map((response: LoyaltyPointActivityListResponse) => {
        return response;
      })
    );
  }

  getCustomerLoyaltyProgram(query?: Query): Observable<PaginatedList<LoyaltyPrograms[]>> {
    const urlId = `${this.customerUrl}/loyalty-program`;
    return this.cacheApi.getWithCache<LoyaltyProgramListResponse>(urlId, query).pipe(
      map(({ content }: LoyaltyProgramListResponse) => ({
        list: content.loyalty_programs,
        pagination: content.pagination,
      }))
    );
  }

  getCustomerLoyaltyProgramDetail(loyaltyId: LoyaltyId): Observable<LoyaltyPrograms> {
    const urlId = `${this.customerUrl}/${loyaltyId}`;
    return this.cacheApi.getWithCache<LoyaltyProgramDetailResponse>(urlId).pipe(
      map((response: LoyaltyProgramDetailResponse) => {
        return response.content.loyalty_programs;
      })
    );
  }
}
